var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1449_21128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.968 24.6825L45.27 13.9945V35.2485L32.968 24.6825ZM17.116 26.4925L21.436 30.2425C22.114 30.8185 22.998 31.1665 23.964 31.1665H23.998H24.024C24.992 31.1665 25.876 30.8165 26.562 30.2365L26.556 30.2405L30.876 26.4905L44.008 37.7685H3.99L17.116 26.4925ZM3.972 11.4605H44.032L24.79 28.1725C24.5737 28.3436 24.3058 28.4366 24.03 28.4365H24.002H23.976C23.6992 28.4368 23.4305 28.343 23.214 28.1705L23.216 28.1725L3.972 11.4605ZM2.73 13.9925L15.03 24.6805L2.73 35.2405V13.9925ZM45.93 9.11047C45.45 8.87047 44.886 8.73047 44.288 8.73047H3.718C3.13832 8.73061 2.56661 8.86549 2.048 9.12447L2.07 9.11447C1.44915 9.42069 0.926296 9.89443 0.560508 10.4822C0.194721 11.0699 0.000574697 11.7482 0 12.4405L0 36.7845C0.00105881 37.7697 0.392905 38.7143 1.08956 39.4109C1.78622 40.1076 2.73078 40.4994 3.716 40.5005H44.282C45.2672 40.4994 46.2118 40.1076 46.9084 39.4109C47.6051 38.7143 47.9969 37.7697 47.998 36.7845V12.4405C47.998 10.9865 47.16 9.72647 45.94 9.12047L45.918 9.11047H45.93Z",
    fill: "#04236B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1449_21128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.730469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.e8a368dfdee5328af6d9e69dec996bb8.svg";
export { ForwardRef as ReactComponent };